const allowedTags = new Set([
  "B",
  "BR",
  "DIV",
  "EM",
  "I",
  "LI",
  "OL",
  "P",
  "STRONG",
  "U",
  "UL",
  "A",
]);

export const sanitizeRichText = (value = "") => {
  if (typeof document === "undefined") return String(value || "");

  const container = document.createElement("div");
  container.innerHTML = String(value || "");
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT);
  const elements = [];
  let current = walker.nextNode();
  while (current) {
    elements.push(current);
    current = walker.nextNode();
  }

  elements.forEach((element) => {
    if (!allowedTags.has(element.tagName)) {
      element.replaceWith(document.createTextNode(element.textContent || ""));
      return;
    }

    [...element.attributes].forEach((attribute) => {
      if (element.tagName !== "A" || attribute.name !== "href") {
        element.removeAttribute(attribute.name);
      }
    });

    if (element.tagName === "A") {
      const href = element.getAttribute("href") || "";
      if (!/^(https?:|mailto:)/i.test(href)) {
        element.replaceWith(document.createTextNode(element.textContent || ""));
      } else {
        element.setAttribute("target", "_blank");
        element.setAttribute("rel", "noreferrer");
      }
    }
  });

  return container.innerHTML;
};
